import { contactWrap, FlowTemplate, photoWidget, sectionIcon, singleColumnPage, type RenderContext } from "../base";
import { col, expanded, hspace, keep, rect, row, text, vspace, type Node, type PageSpec } from "../ir";
import type { RenderSection } from "../model";

/**
 * Aurora — the house style: one clean column, an accent hairline beside every
 * heading, soft accent chips. ATS-safe. (aurora_template.dart)
 */
export class AuroraTemplate extends FlowTemplate {
  readonly info = {
    id: "aurora",
    name: "Aurora",
    tagline: "Crisp, modern and calm — our signature look",
    category: "modern" as const,
    layout: "One column",
    defaultAccent: 0xff0f766e,
    atsFriendly: true,
    supportsPhoto: true,
  };

  readonly fonts = { body: "inter" as const };

  heading(c: RenderContext, s: RenderSection): Node {
    const t = c.t;
    const icon = sectionIcon(c, s, t.accentText, t.fs(10.5));
    return row([
      icon,
      icon && hspace(6),
      text(s.title.toUpperCase(), t.style(t.heading.bold, 9.2, { color: t.accentText, letterSpacing: 1.6, lineSpacing: 0 })),
      hspace(9),
      expanded(rect({ height: 0.7, color: t.line })),
    ]);
  }

  build(c: RenderContext): PageSpec {
    const t = c.t;
    const m = c.model;
    const photo = photoWidget(c, 66);
    const header = row([
      expanded(
        col([
          m.name && text(m.name, t.style(t.display.bold, 25, { color: t.ink, letterSpacing: -0.4, lineSpacing: 0 })),
          m.headline && vspace(4),
          m.headline && text(m.headline, t.style(t.body.semiBold, 11.5, { color: t.accentText, lineSpacing: 0 })),
          m.contacts.length > 0 && vspace(9),
          m.contacts.length > 0 &&
            contactWrap(c, {
              style: t.style(t.body.regular, 8.4, { color: t.muted, lineSpacing: 0 }),
              iconColor: t.accent,
            }),
        ])
      ),
      photo && hspace(18),
      photo,
    ]);
    return singleColumnPage(c, [42, 40, 42, 32], [keep([header, vspace(t.gap(20))]), ...this.allSections(c, m.sections)]);
  }
}
